<div class="wrapper">
    <div class="wrap-header">
        <header>
            <div class="container">
                <nav class="navbar">
                    <a class="navbar-brand" href="/">
                        <img alt="DeltaWizard.ai" height="24" src="assets/images/logo.svg">
                    </a>
                    <ul class="breadcrumb">
                        <li class="breadcrumb-item"><a routerLink="/projects">Projects</a><span class="divider">/</span></li>
                        <!-- <li class="breadcrumb-item">
                            <span>Marketing</span>
                            <span class="divider">/</span>
                        </li> -->
                        <li class="breadcrumb-item">
                            <span [matMenuTriggerFor]="menuBreadcrumb" class="breadcrumb-item__dropdown">
                                <span>{{ projectName }}</span>
                                <span class="material-icons-outlined">keyboard_arrow_down</span>
                            </span>
                            <mat-menu #menuBreadcrumb="matMenu">
                                <a *ngIf="downloadXlsxUrl" target="_blank" [href]="downloadXlsxUrl" mat-menu-item>Download XLS</a>
                                <button type="button" mat-menu-item mwlConfirmationPopover popoverTitle="Confirm delete" popoverMessage="Are you sure?" cancelText="No" confirmText="Yes" placement="top" [appendToBody]="true"
                                                (confirm)="deleteProject()" (click)="$event.stopPropagation()">Delete</button>
                            </mat-menu>
                        </li>
                    </ul>

                    <main-menu></main-menu>
                </nav>
            </div>
        </header>
    </div>

    <main>
        <div class="container container-import-wizard">
            <div class="back-home-link">
                <a routerLink="/projects" class="btn btn-text"><span class="material-icons-outlined">arrow_back</span> <span class="subtitle-2">Back to Projects</span></a>
            </div>
            <div class="import-blocks" [ngClass]="{'loading':false}">
                <control-column-selection #controlColumn (stepCompleted)="onControlColumnStepCompleted($event)" (activated)="userClickedActivateStep($event)"></control-column-selection>
                <series #series (stepCompleted)="onSeriesStepCompleted($event)" (activated)="userClickedActivateStep($event)"></series>
                <outcome-column-selection #outcomeColumn (stepCompleted)="onOutcomeColumnStepCompleted($event)" (activated)="userClickedActivateStep($event)"></outcome-column-selection>
                <formula-input-selection #formula (stepCompleted)="onFormulaStepCompleted($event)" (activated)="userClickedActivateStep($event)"></formula-input-selection>
                <new-lost-column-selection #newLost (stepCompleted)="onNewLostStepCompleted($event)" (activated)="userClickedActivateStep($event)"></new-lost-column-selection>
                <aggregation-settings #aggregationSettings (stepCompleted)="onAggregationsSettingsStepCompleted($event)" (activated)="userClickedActivateStep($event)"></aggregation-settings>
                <calc-options #calcOptions (stepCompleted)="onCalcOptionsStepCompleted($event)" (activated)="userClickedActivateStep($event)"></calc-options>
                <relative-impact-options #relativeImpact (stepCompleted)="onRelativeImpactStepCompleted($event)" (activated)="userClickedActivateStep($event)"></relative-impact-options>
                <dimensions-selection #dimensions (stepCompleted)="onDimensionsStepCompleted($event)" (activated)="userClickedActivateStep($event)"></dimensions-selection>
                <preaggregation-strategy #preaggregationStrategy (stepCompleted)="onPreaggregationStrategyStepCompleted($event)" (activated)="userClickedActivateStep($event)"></preaggregation-strategy>
                <forecast #forecast (stepCompleted)="onForecastStepCompleted($event)" (activated)="userClickedActivateStep($event)"></forecast>
            </div>
            <div class="fit-space-block"></div>
        </div>
    </main>
    <footer>
        <span class="body-2">© DeltaWizard. All rights reserved</span>
    </footer>
</div>
